module.exports = __webpack_public_path__ + "img/lock.e764a3fa.svg";